<template>
    <div class="drag-drop-input">
        <label class="drag-drop-input__label">{{label}}</label>

        <div class="drag-drop-input__values-container" ref="dropzone">
            <span v-for="(item, index) in searchWordPills" :key="index" :class="['drag-drop-input__pill', item.colorClass]">
                {{ item.value }}
                <InlineSvg :src="require(`../../assets/svgs/close.svg`)" class="drag-drop-input__pill-cross" @click="removeSearchWordPill(item)"/>
            </span>

            <input type="text" placeholder="Enter here..." class="drag-drop-input__input" v-model.trim="inputValue" @keyup.enter="addTextInputValue" @blur="addTextInputValue">
        </div>

        <p v-if="searchWordFormError.error" class="formulate-input-error drag-drop-input__error-message">{{ searchWordFormError.text }}</p>
    </div>
</template>

<script>
    import $ from 'jquery';
    import 'jquery-ui/dist/jquery-ui.min';
    import InlineSvg from "vue-inline-svg";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'searchWordInput',
        props: {
            label: {
                type: String,
                required: true
            },
            searchWordFormError: {
                type: Object,
                required: true
            }
        },
        components: {
            InlineSvg
        },
        data() {
            return {
                inputValue: '',
            }
        },
        computed: {
            ...mapGetters('BrandCreator', {
                searchWordPills: 'getSearchWordPills',
                searchWordString: 'getSearchWordString'
            }),
        },
        watch: {
            searchWordString() {
                this.$emit('value-updated', this.searchWordString);
            }
        },
        mounted() {
            $(this.$refs.dropzone).droppable({
                /* eslint-disable */
                drop: (event, ui) => {
                    let colour = ui.draggable[0].classList.contains('brand-centre__pill--blue') ? 'drag-drop-input__pill--blue' : 'drag-drop-input__pill--green';
                    let droppedValue = ui.draggable[0].innerText;

                    let pillObj = {
                        value: droppedValue,
                        colorClass: colour,
                    };

                    this.addSearchWordPill(pillObj);
                }
            });
        },
        methods: {
            ...mapActions('BrandCreator', [
                'addSearchWordPill',
                'removeSearchWordPill'
            ]),
            addTextInputValue() {
                if (this.inputValue.length) {
                    let pillObj = {
                        value: this.inputValue,
                        colorClass: 'drag-drop-input__pill--blue',
                    };

                    this.addSearchWordPill(pillObj);

                    this.inputValue = '';
                }
            },
        }
    }
</script>